<mat-card appearance="outlined" class="mat-elevation-z4">
    <mat-card-content>
        {{ 'Dashboard.NoPermission' | translate }}
    </mat-card-content>
</mat-card>
